import React from 'react'
import {useVariableForm} from '../../../../providers/variables/use-variable-form'
import {
  InputContext,
  StepContextProps,
  TemplateContextProps
} from '../library/context/input'

export const TextEditorWithVariables = (
  props:
    | Omit<TemplateContextProps, 'variablePaths' | 'openVariableForm'>
    | Omit<StepContextProps, 'variablePaths' | 'openVariableForm'>
) => {
  const [openVariableModal] = useVariableForm()

  return <InputContext {...props} openVariableForm={openVariableModal} />
}
